/**
 * CSRF Protection utilities
 */

/**
 * Generate a random CSRF token
 */
export function generateCSRFToken(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

/**
 * Store CSRF token in sessionStorage
 */
export function storeCSRFToken(token: string): void {
  try {
    sessionStorage.setItem('csrf_token', token);
  } catch (error) {
    console.warn('Failed to store CSRF token:', error);
  }
}

/**
 * Retrieve CSRF token from sessionStorage
 */
export function getCSRFToken(): string | null {
  try {
    return sessionStorage.getItem('csrf_token');
  } catch (error) {
    console.warn('Failed to retrieve CSRF token:', error);
    return null;
  }
}

/**
 * Remove CSRF token from sessionStorage
 */
export function clearCSRFToken(): void {
  try {
    sessionStorage.removeItem('csrf_token');
  } catch (error) {
    console.warn('Failed to clear CSRF token:', error);
  }
}

/**
 * Validate origin header for CSRF protection
 */
export function validateOrigin(origin: string | null): boolean {
  const allowedOrigins = [
    window.location.origin,
    'https://uqjjisbrbasocuhmbviz.supabase.co'
  ];
  
  return origin !== null && allowedOrigins.includes(origin);
}

/**
 * Initialize CSRF token if not exists
 */
export function initializeCSRFToken(): string {
  let token = getCSRFToken();
  if (!token) {
    token = generateCSRFToken();
    storeCSRFToken(token);
  }
  return token;
}